<!-- Catalog upload alert temporarily disabled
<div
  *ngIf="catalogAlertVisible"
  class="catalog-sync-alert"
  [class.catalog-sync-alert--tour-active]="showOverlay"
  role="status"
  aria-live="polite">
  <div
    class="catalog-sync-strip"
    [class.catalog-sync-strip--failed]="catalogAlertFailed"
    [class.catalog-sync-strip--enter]="!catalogAlertLeaving"
    [class.catalog-sync-strip--leave]="catalogAlertLeaving"
    data-onboarding="catalog-sync">
    <span *ngIf="!catalogAlertFailed" class="catalog-sync-strip__loader" aria-hidden="true"></span>
    <span *ngIf="catalogAlertFailed" class="catalog-sync-strip__icon-failed" aria-hidden="true">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </span>
    <div class="catalog-sync-strip__text">
      <span class="catalog-sync-strip__title">{{ catalogAlertTitle }}</span>
      <span class="catalog-sync-strip__message">{{ catalogAlertSubtitle }}</span>
    </div>
  </div>
</div>
-->

<div class="onboarding-tour" *ngIf="showOverlay" role="dialog" aria-modal="true" aria-label="Getting started guide">
  <div
    *ngFor="let panel of blockerPanels"
    class="onboarding-tour__blocker"
    [style.top.px]="panel.top"
    [style.left.px]="panel.left"
    [style.width.px]="panel.width"
    [style.height.px]="panel.height"
    aria-hidden="true">
  </div>

  <div
    *ngIf="useFullBackdrop"
    class="onboarding-tour__backdrop"
    aria-hidden="true">
  </div>

  <div
    *ngIf="spotlight"
    class="onboarding-tour__spotlight"
    [class.onboarding-tour__spotlight--ring]="useSpotlightBlocker"
    [style.top.px]="spotlight.top"
    [style.left.px]="spotlight.left"
    [style.width.px]="spotlight.width"
    [style.height.px]="spotlight.height">
  </div>

  <div
    #tooltipCard
    class="onboarding-tour__card"
    [class.onboarding-tour__card--success]="isActivationSuccessMode"
    [ngStyle]="cardStyle"
    *ngIf="currentStep">
    <div class="onboarding-tour__card-header">
      <div class="onboarding-tour__title-row">
        <span *ngIf="isActivationSuccessMode" class="onboarding-tour__success-icon" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <h3 class="onboarding-tour__title">{{ tourCardTitle }}</h3>
      </div>
      <button type="button" class="onboarding-tour__close" (click)="skip()" aria-label="Close guide">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <div class="onboarding-tour__body">
      <p class="onboarding-tour__description">{{ tourCardDescription }}</p>

      <div
        *ngIf="showCatalogStatus"
        class="onboarding-tour__catalog-status"
        [class.onboarding-tour__catalog-status--failed]="catalogSyncFailed">
        <span *ngIf="!catalogSyncFailed" class="onboarding-tour__catalog-status-loader" aria-hidden="true"></span>
        <span *ngIf="catalogSyncFailed" class="onboarding-tour__catalog-status-icon" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </span>
        <div class="onboarding-tour__catalog-status-copy">
          <span class="onboarding-tour__catalog-status-title">{{ catalogStatusTitle }}</span>
          <span class="onboarding-tour__catalog-status-message">{{ catalogStatusMessage }}</span>
        </div>
      </div>

      <p class="onboarding-tour__hint" *ngIf="showStandardHint">{{ gateMessage }}</p>

      <p class="onboarding-tour__hint onboarding-tour__hint--info" *ngIf="showActivateFirstHint">
        Turn on the activation toggle above to continue.
      </p>
    </div>

    <div class="onboarding-tour__footer">
      <div class="onboarding-tour__actions">
        <button type="button" class="onboarding-tour__btn onboarding-tour__btn--ghost" (click)="skip()">
          Skip
        </button>
        <div class="onboarding-tour__nav">
          <button
            *ngIf="!isActivationSuccessMode"
            type="button"
            class="onboarding-tour__btn onboarding-tour__btn--secondary"
            (click)="previous()"
            [disabled]="currentIndex === 0">
            Previous
          </button>
          <button
            type="button"
            class="onboarding-tour__btn onboarding-tour__btn--primary"
            (click)="next()"
            [disabled]="!canClickPrimary">
            {{ primaryActionLabel }}
          </button>
        </div>
      </div>

      <div class="onboarding-tour__progress-row">
        <div class="onboarding-tour__progress">
          <span
            *ngFor="let i of progressSteps"
            class="onboarding-tour__dot"
            [class.onboarding-tour__dot--active]="i === (displayStepNumber - 1)"
            [class.onboarding-tour__dot--done]="i < (displayStepNumber - 1)">
          </span>
        </div>
        <span class="onboarding-tour__badge">Step {{ displayStepNumber }}/{{ displayTotalSteps }}</span>
      </div>
    </div>
  </div>
</div>
